import SpinnerComponent from './spinner'

const spinner = {
  install(Vue) {
    Vue.component(SpinnerComponent.name, SpinnerComponent)
  }
}

export default spinner